
















import Vue from 'vue';
import { getContentArea } from '@/contentful';
import { UserModel } from '@/@types/member';
import { sso, HEALTHEQUITY_API_SUB_URLS } from '@/api';
import { EventBus } from '@/event-bus';

interface Data {
  message: string | null;
  ssoUrl: string;
  formData: any;
  clientName: string;
}

export default Vue.extend({
  name: 'FederateHQY',
  beforeMount() {
    getContentArea('further-to-classic').then((message) => {
      if (message) {
        this.message = message.fields.content;
      }
    });
  },
  mounted() {
    this.redirectHQYSSO();
  },
  data(): Data {
    return {
      message: '',
      ssoUrl: '',
      formData: {},
      clientName: process.env.VUE_APP_CLIENT_NAME,
  };
  },
  computed: {
  user(): UserModel {
    return this.$store.getters.user;
  },
},
  methods: {
    // Redirect to Classic based on session role
    redirectHQYSSO() {
      const memberId = this.user.memberId;
      const JWT = this.$store.getters.userJWT;
      sso.post(`${HEALTHEQUITY_API_SUB_URLS.healthEquitySso}/${memberId}/healthequity-federations`, {
        headers: {
          Authorization: JWT,
        },
      })
        .then((response) => {
          this.ssoUrl = process.env.VUE_APP_HQY_SSO_URL;
          this.formData = response.data;

          this.$nextTick(() => {
            (this.$refs.sso as any).submit();
          });
        })
        .catch(() => {
          EventBus.$emit('openModal', 'Error', {
            message: 'sso-redirect-error_unable-to-perform-redirect',
          });
        });
    },
  },
});
